<div class="responsive-navigation visible-sm visible-xs">
    <a class="menu-toggle-btn">
        <fa-icon [icon]="['fas', 'bars']" (click)="toggleMenu()"></fa-icon>
    </a>
    <section class="responsive_menu collapsible" [@collapse]="!isCollapsed">
        <div class="menu-top-container">
            <ul id="menu-top" class="main_menu">
                <li id="menu-item-23"
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-23">
                    <a (click)="toggleMenu()" routerLink="/home" routerLinkActive="activeNavBar">Home</a></li>
                <li id="menu-item-1004" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1004">
                    <a (click)="toggleMenu()" routerLink="/online-lehrgaenge" routerLinkActive="activeNavBar">Online-Lehrgänge</a></li>
                <li id="menu-item-21"
                    class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-7 current_page_item menu-item-21">
                    <a (click)="toggleMenu()"  routerLink="/events" routerLinkActive="activeNavBar">Anmeldung / Termine</a></li>
                <li id="menu-item-1013" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1013">
                    <a (click)="toggleMenu()" routerLink="/kosten-storno" routerLinkActive="activeNavBar">Zahlungsbedingungen</a>
                    <ul class="submenu">
                        <li>
                            <a (click)="toggleMenu()" routerLink="/storno-umbuchung" routerLinkActive="activeNavBar">Storno & Umbuchung</a>
                        </li>
                        <li>
                            <a (click)="toggleMenu()" routerLink="/widerruf" routerLinkActive="activeNavBar">Widerruf</a>
                        </li>
                    </ul>
                </li>
                <li id="menu-item-20" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-20">
                    <a (click)="toggleMenu()" routerLink="/anmeldung" routerLinkActive="activeNavBar">Kontakt</a></li>
                <li id="menu-item-19" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-19">
                    <a (click)="toggleMenu()" routerLink="/faq" routerLinkActive="activeNavBar">FAQ</a></li>
            </ul>
        </div>
    </section> <!-- /.responsive_menu -->
</div> <!-- /responsive_navigation  -->

<app-notifications-outlet></app-notifications-outlet>

<app-header></app-header>

<!-- Page Title -->
<div class="container" *ngIf="isHome">
    <div class="page-title clearfix">
        <div class="row">
            <div class="col-md-12">
                <h6>
                    <a routerLink="/">Home</a>
                </h6>
                <h6>
                    <span class="page-active">{{ currentData }}</span>
                </h6>
            </div>
        </div>
    </div>
</div>

<!--  Loading Indicator
<div id="app-loading-indicator" data-test="app-progressbar">
    @if (isLoadingService.isLoading) {
        <p-progressBar [style]="{ height: '5px' }" mode="indeterminate"></p-progressBar>
    }
</div>-->


<!-- main content -->
<div>
    <!-- row -->
    <div>
        <!-- component widget -->
        <div></div>

        <!-- login widget -->
        <div></div>
    </div>
</div>

<div class="container">
    <div class="row">
        <router-outlet></router-outlet>

        <app-login *ngIf="!isLoggedIn"></app-login>
        <app-user-navigation *ngIf="isLoggedIn"></app-user-navigation>

    </div>
</div>

<app-footer></app-footer>
<app-wichtige-informationen></app-wichtige-informationen>
